import type { UnknownRecord } from "@/utils/type";

import { ApplicationError } from "./ApplicationError";

export class UnauthenticatedError extends ApplicationError {
  constructor(cause: UnknownRecord = {}) {
    super("UnauthenticatedError", "", { cause });
  }
}
